import styled from "styled-components";

export const Title = styled.div`
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
`

export const Container = styled.div`
    display: flex;
    gap: 12px;
`